import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../../../lib/utils.js';

export type CardVariant = 'default' | 'outlined' | 'elevated';

const variantClasses: Record<CardVariant, string> = {
  default: 'border border-ig-border bg-ig-surface-card',
  outlined: 'border border-ig-border-strong bg-ig-bg-elevated',
  elevated: 'border border-ig-border bg-ig-bg-elevated shadow-lg shadow-black/5',
};

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Optional title rendered at the top of the card. */
  title?: string;
  /** Optional supporting text rendered below the title. */
  description?: string;
  /** Footer content rendered at the bottom of the card. */
  footer?: ReactNode;
  /** Visual style variant. */
  variant?: CardVariant;
}

export function Card({ className, title, description, footer, variant = 'default', children, ...props }: CardProps) {
  return (
    <div className={cn('rounded-lg p-4 text-ig-text-primary', variantClasses[variant], className)} {...props}>
      {(title || description) && (
        <header className="mb-3 space-y-1">
          {title && <h3 className="text-head-20 font-semibold">{title}</h3>}
          {description && <p className="text-body-14 text-ig-text-secondary">{description}</p>}
        </header>
      )}
      {children && <div>{children}</div>}
      {footer && <footer className="mt-4 border-t border-ig-border pt-3">{footer}</footer>}
    </div>
  );
}
